export enum ProyectoEstado {
  Planificado,
  EnProceso,
  Demorado,
  Finalizado,
}

export const ProyectoEstadoLabels: { [key in ProyectoEstado]: string } = {
  [ProyectoEstado.Planificado]: 'Planificado',
  [ProyectoEstado.EnProceso]: 'EnProceso',
  [ProyectoEstado.Demorado]: 'Demorado',
  [ProyectoEstado.Finalizado]: 'Finalizado',
};

export const getProyectoEstado = () => {
  return Object.values(ProyectoEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: ProyectoEstadoLabels[id as ProyectoEstado],
    }));
};

export const colorMapping: { [key in ProyectoEstado]: string } = {
  [ProyectoEstado.Planificado]: '#22c55e',
  [ProyectoEstado.EnProceso]: '#70BDFF',
  [ProyectoEstado.Demorado]: 'orange',
  [ProyectoEstado.Finalizado]: '#FF0000',
};
